'use client';

import type { ComponentProps, ComponentType, ReactNode } from 'react';
import { useIsClient } from '../hooks';
type OmitKeyof<TObject, TKey extends (TStrictly extends 'safely' ? keyof TObject | (string & Record<never, never>) | (number & Record<never, never>) | (symbol & Record<never, never>) : keyof TObject), TStrictly extends 'strictly' | 'safely' = 'strictly'> = Omit<TObject, TKey>;
type PropsWithoutChildren<T extends {
  children?: unknown;
}> = OmitKeyof<T, 'children'>;
export type ClientOnlyProps = {
  children: ReactNode;
  fallback?: ReactNode;
};

/**
 * This component ensures its children are only rendered on the client-side.
 */
export const ClientOnly = Object.assign(({
  children,
  fallback
}: ClientOnlyProps) => <>{useIsClient() ? children : fallback}</>, {
  displayName: 'ClientOnly',
  with: <TProps extends ComponentProps<ComponentType> = Record<string, never>,>(clientOnlyProps: PropsWithoutChildren<ClientOnlyProps>, Component: ComponentType<TProps>) => Object.assign((props: TProps) => <ClientOnly {...clientOnlyProps}>
            <Component {...props} />
          </ClientOnly>, {
    displayName: `${ClientOnly.displayName}.with(${Component.displayName || Component.name || 'Component'})`
  })
});